import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
	REMINDER_ID_PARAM,
	REMINDER_SCROLL_PARAM,
	REMINDER_SCROLL_VALUE,
	REMINDERS_SECTION_ANCHOR_ID,
} from "web_myplann/NotificationCenter/Utils/reminderScrollParam";

export const useScrollToReminders = (isReady: boolean): void => {
	const [searchParams] = useSearchParams();
	const hasScrolledRef = useRef(false);
	const shouldScroll =
		searchParams.get(REMINDER_SCROLL_PARAM) === REMINDER_SCROLL_VALUE;
	// A specific-reminder deep link is handled by useScrollToReminderRow inside
	// the reminders list, which only becomes ready once its own query resolves —
	// scrolling to the section here would mark the scroll done too early.
	const targetsSpecificReminder = searchParams.get(REMINDER_ID_PARAM) !== null;

	useEffect(() => {
		if (
			!shouldScroll ||
			targetsSpecificReminder ||
			!isReady ||
			hasScrolledRef.current
		) {
			return;
		}
		const element = document.getElementById(REMINDERS_SECTION_ANCHOR_ID);
		if (!element) {
			return;
		}
		hasScrolledRef.current = true;
		requestAnimationFrame(() => {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		});
	}, [shouldScroll, targetsSpecificReminder, isReady]);
};
